import moment from 'moment';
import accountTemplate from './accounts.html';
import { keyLanguage } from 'fides-angularjs-components/src/fts-services/fts-user-service';
import { AccountService } from '../../../services/AccountService';
import {
    banks,
    currencyAccounts,
    byCountySummary,
    byGroupSummary,
    balanceHistory,
    byAccountSummary,
    count, accounts
} from '../../../services/arsweb/RoutingPaths';
import { CurrencyService } from '../../../services/CurrencyService';
import { ChartUtil } from '../../../utils/chart/ChartUtil';
import { TAB_OVERVIEW, TAB_BANK, TAB_CURRENCY, TAB_GROUP, TAB_COUNTRY } from '../../../views/accounts/overview';
import {REPORT_TYPE} from "../../report/ReportModalController";
import {EXPORT_TYPE} from "../../export/ExportModalController";
import {CommonViewController, CONSOLIDATION_CURRENCY_PARAMS} from "../../../controller/CommonViewController";
import {DEF_CURRENCY} from "../../../views/dashboard/dashboard";

export const TOP_NUMBER = 5;
export const CONSOLIDATION_CURRENCY = 'consolidationCurrency';

/** @ngInject */
export function accountsView() {
    return {
        restrict: 'E',
        scope: {
            controller: '=',
            tabName: '=',
            showListGrouped: '=',
            tabs: '=',
            selectedIndex: '='
        },
        transclude: 'true',
        templateUrl: accountTemplate,
        controller: AccountsController,
        controllerAs: 'accountsController',
    };
}
const GROUPDATA_CHANGE = 'groupData.change';

export class AccountsController extends CommonViewController {
    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies);
        this.controller = $scope.controller;
        this.tabNameId = arsMainDependencies.$state.params.tabName;
        this.userService = userService;
        this.accountService = new AccountService(userService);
        this.currencyService = new CurrencyService(userService.fsMainDependencies);
        this.topNumber = TOP_NUMBER;
        this.filterFormatter =  userService.filterFormatter;
        this.supportedReports = [REPORT_TYPE.MT940_STATEMENTS, REPORT_TYPE.PDF_STATEMENTS_COMBINED, REPORT_TYPE.PDF_STATEMENTS_SEPARATED,
            REPORT_TYPE.XLS_TRANSACTION_REPORT, REPORT_TYPE.CSV_TRANSACTION_REPORT,
            REPORT_TYPE.MT942_INTRADAYS, REPORT_TYPE.PDF_INTRADAYS, REPORT_TYPE.XLS_TRANSACTION_INTRADAY_REPORT, REPORT_TYPE.CSV_TRANSACTION_INTRADAY_REPORT];

        this.supportedExports = [EXPORT_TYPE.CSV, EXPORT_TYPE.XLSX, EXPORT_TYPE.PDF_ACCOUNT_OVERVIEW];

        this.pieOptionsBank = {
            series: {
                pie: {
                    show: true,
                    radius: 0.9,
                    label: {
                        show: false
                    }
                }
            },
            grid: {
                hoverable: true,
                clickable: true
            },
            legend: {
                show: true,
                noColumns: 2,
                container: '#legendContainerBank',
                labelFormatter: this.controller.flotService.legendLabel
            }
        };
        this.pieOptionsCurr =  {
            series: {
                pie: {
                    show: true,
                    radius: 0.9,
                    label: {
                        show: false
                    }
                }
            },
            grid: {
                hoverable: true,
                clickable: true
            },
            legend: {
                show: true,
                noColumns: 2,
                container:'#legendContainerCurr',
                labelFormatter: this.controller.flotService.legendLabel
            }
        };

        // PREPARE DATA
        $scope.bankpromise = null;
        $scope.countrypromise = null;
        $scope.currencypromise = null;
        $scope.grouppromise = null;

        // Date selection
        this.pickedDate = new Date();
        this.minDate = moment().add(-3, 'month').toDate();
        this.maxDate = new Date();

        this.ftsMainDependencies.initCompletedPromise.then(() => this.loadTabItems($scope));
    }

    $onInit() {
        this.currencyService.getCurrencies().then(data => {
            this.mainCurrencies = data;
        });
    }

    loadTabItems($scope) {
        if (this.sessionPersistance && this.sessionPersistance.promise) {
            this.sessionPersistance.promise.then(() => {
                $scope.consolitationcurrency = this.sessionPersistance.get(CONSOLIDATION_CURRENCY) || DEF_CURRENCY;
                this.refreshData();
            });
        } else {
            $scope.consolitationcurrency = DEF_CURRENCY;
            this.refreshData();
        }
    }

    refreshData() {
        this.loading = true;
        this.ftsMainDependencies.$rootScope.pickedDate = this.pickedDate;
        this.ftsMainDependencies.$rootScope.consolidationCurrency = this.$scope.consolitationcurrency.code;
        this.accountService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = this.$scope.consolitationcurrency.code;
        this.accountService.service.config.params['date-to'] = this.pickedDate.valueOf();

        if(this.tabNameId !== TAB_COUNTRY) {
            this.loadBalanceHistory().then(()=> this.loadFilterItems());
        } else {
            this.loadFilterItems();
        }
    }

    selectConsolidationCurrency (currency) {
        this.$scope.consolitationcurrency = currency;
        this.sessionPersistance.set(CONSOLIDATION_CURRENCY, currency);

        this.refreshData();
        this.$scope.$broadcast('consolidationCurrency.change', currency);
    }

    selectDateSnapshot() {
        this.pickedDate = moment(this.pickedDate);
        this.refreshData();
        this.$scope.$broadcast('dateSnapshot.change', this.pickedDate);
    }

    loadFilterItems() {
        if (this.tabNameId === TAB_OVERVIEW) {
            // All banks
            this.$scope.accountpromise = this.loadAccountsTabInfo();
        }

        if (this.tabNameId === TAB_BANK) {
            // All banks
            this.$scope.bankpromise = this.loadBankTabInfo();
        }

        if(this.tabNameId === TAB_CURRENCY) {
            // All user account currencies
            this.$scope.currencypromise = this.loadCurrencyTabInfo();
        }

        if( this.tabNameId === TAB_COUNTRY) {
            // All countries
            this.$scope.countrypromise = this.loadCountryTabInfo();
        }

        if (this.tabNameId === TAB_GROUP) {
            // group informaiton only under groups
            this.$scope.grouppromise = this.loadGroupTabInfo();
        }
    }

    loadAccountsTabInfo() {
        return this.accountService.getUserSummaryData(byAccountSummary).then(accountSummary => {
            this.$scope.accountSummary = accountSummary.accountSummaries;
            this.getTotalSum(accountSummary);
            const accountSummaries = accountSummary.accountSummaries || [];
            if (accountSummaries.length > 0){
                this.$scope.mostUsedAccounts =  accountSummaries.slice(0, this.topNumber);
                this.controller.flotService.constructList(accountSummaries, this.$scope.mostUsedAccounts, this.userService);
            }
        });
    }

    loadCurrencyTabInfo() {
        return this.accountService.getUserSummaryData(currencyAccounts).then(currencyData => {

            this.$scope.currencydata = currencyData.accountSummaries;
            this.getTotalSum(currencyData);

            if(currencyData.accountSummaries !== null && currencyData.accountSummaries.length > 0){
                this.loadCurrencyDep(currencyData.accountSummaries);
            }
            this.$scope.$broadcast(GROUPDATA_CHANGE, this.$scope.currencydata);
        });
    }

    loadBankTabInfo() {
        return this.accountService.getUserSummaryData(banks).then(byBankSummariesData => {

            this.$scope.bankdata = byBankSummariesData.accountSummaries;
            this.getTotalSum(byBankSummariesData);

            if(byBankSummariesData.accountSummaries !== null && byBankSummariesData.accountSummaries.length > 0){
                this.loadBankDep(this.$scope.bankdata);
            }
            this.$scope.$broadcast(GROUPDATA_CHANGE, this.$scope.bankdata);
        });
    }

    loadGroupTabInfo() {
       return this.accountService.getUserSummaryData(byGroupSummary).then(groupData => {

            if(groupData) {
                this.$scope.groupdata = groupData.accountSummaries;
                this.getTotalSum(groupData);

                if(groupData.accountSummaries !== null && groupData.accountSummaries.length > 0){
                    this.loadGroupDep(groupData.accountSummaries);
                }

                this.$scope.$broadcast(GROUPDATA_CHANGE, this.$scope.groupdata);
            }
        });
    }

    loadCountryTabInfo() {
        return this.accountService.getUserSummaryData(byCountySummary).then(accountData => {

            this.$scope.worldmapdata = accountData.accountSummaries;
            this.getTotalSum(accountData);

            if(accountData.accountSummaries !== null && accountData.accountSummaries.length > 0){
                this.loadCountryDep(this.$scope.worldmapdata);
            }
            this.$scope.$broadcast(GROUPDATA_CHANGE, this.$scope.worldmapdata);
        });
    }

	getTotalSum(sumData) {
        this.loading = false;
		if(sumData.totalFigure !== null) {
            this.userService.promise.then(() => {
                this.$scope.totalSum = this.filterFormatter('fsNumber')(
                    this.tabNameId !== TAB_GROUP ? sumData.totalFigure.amount : this.accountsTotal.balance,
                    this.tabNameId !== TAB_GROUP ? sumData.totalFigure.fractionDigits : this.accountsTotal.fractionDigits);
            });
		}
        if(this.tabNameId !== TAB_GROUP) {
            this.$scope.numberOfAccounts = sumData.accountSummaries.reduce((o, a)=> o + a.numberOfAccounts, 0);
        } else {
            this.accountService.getUserData(accounts + count).then(data => this.$scope.numberOfAccounts = data);
        }
	}

    // loading currency dependencies, for graphic, consolidation curr and tab curr
    loadCurrencyDep(currencydata) {
        this.$scope.mostUsedCurrencies = currencydata.slice(0, this.topNumber);
        this.pieDataset = this.controller.flotService.constructChart(currencydata, this.$scope.mostUsedCurrencies, this.userService);
    }

    // loading bank dependencies, for graphic, consolidation curr and tab bank
    loadBankDep(bankdata) {
        this.$scope.mostUsedBanks = bankdata.slice(0, this.topNumber);
        this.pieBankDataset = this.controller.flotService.constructChart(bankdata, this.$scope.mostUsedBanks, this.userService);
    }

    infoPop(toasterBody) {
        this.controller.infoPop(toasterBody);
    }

    // loading country dependencies, for graphic, consolidation curr and tab curr
    loadCountryDep(countrydata) {
        this.$scope.mostUsedCountries =  countrydata.slice(0, this.topNumber);
        this.controller.flotService.constructList(countrydata, this.$scope.mostUsedCountries, this.userService);
    }

    // loading group dependencies, for graphic
    loadGroupDep(groupdata) {
        this.$scope.mostUsedGroups = groupdata.slice(0, this.topNumber + 1 );
        this.controller.flotService.formatAmounts(this.userService, this.$scope.mostUsedGroups);
    }

    loadBalanceHistory() {
        this.selDay = 10;
        this.balanceDataset = [];
        this.noData = false;
        this.accountService.service.config.params['days'] = this.selDay;

        return this.userService.promise.then(()=> {

            this.balanceHistoryMonths =  ChartUtil.getBalanceMonthTitle(this.selDay,
             this.store.get(keyLanguage) || this.ftsMainDependencies.settings.language,
             moment(this.pickedDate || new Date()));

            this.barChartOptions = ChartUtil.getBarChartOptions(this.filterFormatter);
            return this.accountService.getUserSummaryData(balanceHistory).then((data) => {
                if(data.length > 0) {
                    const positive = [];
                    const negative = [];
                    data.forEach((it, i) => {
                        if (it.closingBalance >= 0) {
                            positive.push([new Date(it.date), it.closingBalance]);
                        } else {
                            negative.push([new Date(it.date), it.closingBalance]);
                        }

                        if(i === 0) {
                            this.barChartOptions.series.fractionDigits = it.fractionDigits;
                        }
                        if(i === 9) { // last day balance position
                            this.accountsTotal = {balance: it.closingBalance, fractionDigits: it.fractionDigits};
                        }
                    });
                    this.balanceDataset = [ { data: positive},{ data: negative }];
                } else  {
                    this.noData = true;
                }
            });
        });
    }
}
